import React, { useState, useEffect } from 'react'
import {
  TextField,
  Button,
  Typography,
  InputLabel,
  FormControl,
  MenuItem,
  Select
} from '@material-ui/core'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

import { NumericFormat } from 'react-number-format'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import RemoveCircleOutlineOutlined from '@material-ui/icons/RemoveCircleOutlineOutlined'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'

import useStyles from './styles'
import 'react-datepicker/dist/react-datepicker.css'
import axios from 'axios'
import { Link, useNavigate, useLocation } from 'react-router-dom'

import {
  API_URL,
  UpdateSuccess,
  ColorCode,
  ColorCodeName,
  Volume,
  Total,
  DashBoard,
  URL,
  AddColorCode,
  Close,
  Save,
  SearchByColorCode,
  ExitColorCode,
  GoBack
} from '../../constants/actionTypes'
import uuid from 'react-uuid'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'

const FormViewListColor = () => {
  // const navigate = useNavigate()
  const [open, setOpen] = React.useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  const API = axios.create({
    baseURL: API_URL
  })
  let data = useLocation()
  const location = useLocation()
  const myQuery = location.search
  const id = myQuery.split('=')[1]
  const navigate = useNavigate()
  // const loginSuccess = JSON.parse(localStorage.getItem('colorMixing'))
  // if (!loginSuccess) {
  //   navigate(URL + '/')
  // }
  const [colorCodeInfoList, setColorCodeInfoList] = useState([
    { colorCode: '', colorName: '', percent: 0, volume: 0, total: 0 }
  ])
  const [dialogContent, setDialogContent] = useState('')
  const [dataColors, setDataColors] = useState([])
  const [sortDataColors, setSortDataColors] = useState([])
  const [postData, setPostData] = useState({
    id: uuid(),
    createDate: '',
    nameCode: '',
    colorCode: '',
    volume: '',
    filter: ''
  })

  const classes = useStyles()
  const updateJson = (jsonData) => API.post('/newhipic/listColor', jsonData)

  const filterBySearch = (e) => {
    // Access input value
    const nameInput = e.target.value
    setPostData({ ...postData, filter: nameInput })
    const query = e.target.value
    // Create copy of item list
    var updatedList = [...dataColors]

    // Include all elements which includes the search query
    updatedList = updatedList.filter(
      (item) => item.colorCode.toLowerCase().indexOf(query.toLowerCase()) !== -1
    )

    setSortDataColors(updatedList)
  }
  const handleSubmit = async (e) => {
    e.preventDefault()

    if (postData && postData.id !== '') {
      const data = {
        id: postData.id,
        nameCode: postData.nameCode.trim(),
        colorCode: postData.colorCode.trim().toUpperCase(),
        volume: postData.volume
      }

      const dataEdit = dataColors.filter((item) => item.id !== postData.id)
      const checkExit = dataColors.filter(
        (item) => item.colorCode == postData.colorCode
      )
      console.log(checkExit)
      let getColorID = ''

      dataColors.forEach((item) => {
        if (item.colorCode == postData.colorCode) {
          getColorID = item.id
        }
      })
      console.log(postData.id)
      console.log(checkExit.length)
      console.log(getColorID)
      if (checkExit.length > 1 && postData.id == '') {
        setDialogContent(ExitColorCode)
        setOpen(true)
      } else if (checkExit.length == 0) {
        dataEdit.push(data)
        setDataColors(dataEdit)
        setSortDataColors(dataEdit)
        updateJson(dataEdit)
        setDialogContent(UpdateSuccess)
        setOpen(true)
      } else if (checkExit.length == 1 && getColorID == postData.id) {
        dataEdit.push(data)
        setDataColors(dataEdit)
        setSortDataColors(dataEdit)
        updateJson(dataEdit)
        setDialogContent(UpdateSuccess)
        setOpen(true)
      } else {
        setDialogContent(ExitColorCode)
        setOpen(true)
      }
    } else {
      const data = {
        id: uuid(),
        nameCode: postData.nameCode.trim(),
        colorCode: postData.colorCode.trim(),
        volume: postData.volume
      }
      const checkExit = dataColors.filter(
        (item) =>
          item.colorCode
            .toLowerCase()
            .indexOf(postData.colorCode.toLowerCase()) !== -1
      )

      if (checkExit.length > 0) {
        setDialogContent(ExitColorCode)
        setOpen(true)
      } else {
        dataColors.push(data)
        updateJson(dataColors)
        setDialogContent(UpdateSuccess)
        setOpen(true)
        setPostData({
          id: '',
          nameCode: '',
          colorCode: '',
          volume: ''
        })
      }
    }

    // setTimeout(() => {
    //   navigate(URL + '/dashboard')
    // }, 3000)
  }
  const handleAdd = () => {
    setPostData({
      id: '',
      nameCode: '',
      colorCode: '',
      volume: ''
    })
  }
  const handleEdit = (id) => {
    const dataEdit = dataColors.filter((item) => item.id == id)

    setPostData({
      ...postData,

      id: dataEdit[0].id,
      nameCode: dataEdit[0].nameCode,
      colorCode: dataEdit[0].colorCode,
      volume: dataEdit[0].volume
    })
  }
  const handleDelete = async (id) => {
    const dataDelete = dataColors.filter((item) => item.id !== id)
    setPostData({
      id: '',
      nameCode: '',
      colorCode: '',
      volume: ''
    })
    setDataColors(dataDelete)
    setSortDataColors(dataDelete)
    updateJson(dataDelete)
    setDialogContent(UpdateSuccess)
    setOpen(true)
  }
  const handleChange = (e) => {
    const { name, value } = e.target
    setPostData({ ...postData, [name]: value })
  }

  const getColorById = async (id, dataEditColor) => {
    const dataEdit = dataEditColor.filter((item) => item.id == id)
    setColorCodeInfoList(dataEdit[0].content)
    setPostData({
      ...postData,

      id: dataEdit[0].id,
      type: dataEdit[0].type,
      category: dataEdit[0].category,
      createDate: dataEdit[0].createDate,
      info: dataEdit[0].info,
      nameCode: dataEdit[0].nameCode,
      colorCode: dataEdit[0].colorCode,
      vehicleName: dataEdit[0].vehicleName,
      version: dataEdit[0].version,
      volume: dataEdit[0].volume,
      content: dataEdit[0].content
    })
    // setDataColorEdit(dataEdit)
  }

  const getAllColors = async () => {
    let arrayData = []
    let arrayCategory = []
    let dataColorMixingPath = ''
    // if (location.state.rePrint) {
    dataColorMixingPath = `${API_URL}/uploadshipic/src3/dataListColorHipic.json`
    axios
      .get(dataColorMixingPath, {
        crossdomain: true
      })
      .then((res) => {
        const dataColorMixing = res.data
        dataColorMixing.map((items) => {
          arrayData.push({
            id: items.id,
            colorCode: items.colorCode,
            nameCode: items.nameCode,
            volume: items.volume
          })
        })

        setDataColors(arrayData)
        setSortDataColors(arrayData)
        //  getColorById(id, arrayData)
      })
      .catch((error) => {
        console.log(error)
      })
  }
  useEffect(() => {
    if (postData.filter == '' || !postData.filter) {
      getAllColors()
      // }
    }
  }, [postData])

  return (
    <Paper className={classes.paper} style={{ backgroundColor: 'transparent' }}>
      <form
        encType='multipart/form-data'
        autoComplete='off'
        noValidate
        className={`${classes.root} ${classes.form}`}
        onSubmit={handleSubmit}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={4}>
              <div className={classes.viewColorLeft}>
                <div style={{}}>
                  <Link
                    to={{
                      pathname: URL + '/dashboard',
                      state: { fromDashboard: true }
                    }}
                  >
                    <Button
                      style={{ marginLeft: '0px', marginBottom: '10px' }}
                      className={classes.buttonLink}
                      type='button'
                    >
                      {GoBack}
                    </Button>
                  </Link>
                </div>
                <div className='wrapInput'>
                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                      className={classes.fileInput}
                      name='colorCode'
                      variant='outlined'
                      label={ColorCode}
                      fullWidth
                      value={postData.colorCode || ''}
                      onChange={(e) => handleChange(e)}
                    />
                  </FormControl>
                  <FormControl fullWidth className={classes.formControl}>
                    <TextField
                      className={classes.fileInput}
                      name='nameCode'
                      variant='outlined'
                      label={ColorCodeName}
                      fullWidth
                      value={postData.nameCode || ''}
                      onChange={(e) => handleChange(e)}
                    />
                  </FormControl>

                  <FormControl fullWidth className={classes.formControl}>
                    <NumericFormat
                      className={classes.fileInput}
                      name='volume'
                      variant='outlined'
                      label={Volume}
                      fullWidth
                      value={postData.volume || ''}
                      onChange={(e) => handleChange(e)}
                      customInput={TextField}
                      valueIsNumericString
                    />
                  </FormControl>
                </div>
                <div className='moreButton'>
                  <Button className={classes.buttonLink} type='submit'>
                    {Save}
                  </Button>
                  <Button
                    style={{ marginLeft: '10px' }}
                    className={classes.buttonLink}
                    onClick={handleAdd}
                  >
                    {AddColorCode}
                  </Button>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <div className={classes.displayResult}>
                <div className='wrapInput'>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    style={{ position: 'relative' }}
                  >
                    <TextField
                      className={classes.fileInput}
                      name='search'
                      variant='outlined'
                      label={SearchByColorCode}
                      fullWidth
                      value={postData.filter}
                      onChange={filterBySearch}
                    />
                  </FormControl>
                </div>
                <TableContainer component={Paper}>
                  <Table aria-label='simple table'>
                    <TableHead>
                      <TableRow>
                        <TableCell align='center'>STT</TableCell>
                        <TableCell align='center'>{ColorCode}</TableCell>
                        <TableCell align='center'>{ColorCodeName}</TableCell>
                        <TableCell align='center'>{Volume} (g)</TableCell>
                        <TableCell align='center'></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody
                      style={{
                        minHeight: '100px',
                        background: '#fff',
                        width: '100%',
                        display: 'inline-masonry'
                      }}
                    >
                      {sortDataColors !== '' &&
                        sortDataColors?.map((row, index) => {
                          return (
                            <TableRow
                              key={row.colorCode}
                              sx={{
                                '&:last-child td, &:last-child th': {
                                  border: 0
                                }
                              }}
                            >
                              <TableCell
                                align='center'
                                component='th'
                                scope='row'
                                style={{ padding: ' 8px' }}
                              >
                                {index + 1}
                              </TableCell>
                              <TableCell
                                align='center'
                                scope='row'
                                style={{ padding: ' 8px' }}
                              >
                                {row.colorCode}
                              </TableCell>
                              <TableCell
                                align='center'
                                style={{ padding: ' 8px' }}
                              >
                                {row.nameCode}
                              </TableCell>
                              <TableCell
                                align='center'
                                style={{ padding: ' 8px' }}
                              >
                                {row.volume} (g)
                              </TableCell>
                              <TableCell
                                align='center'
                                style={{ padding: ' 8px' }}
                              >
                                {' '}
                                <Button
                                  style={{ padding: ' 0px' }}
                                  onClick={() => {
                                    handleDelete(row.id)
                                    // if (window.confirm(`${AreYouSureToDelete}`)) {
                                    //   handleDelete(row.vehicleName)
                                    // }
                                  }}
                                >
                                  <RemoveCircleOutlineOutlined
                                    style={{ color: 'red' }}
                                  />
                                </Button>
                                <Button
                                  style={{ padding: ' 0px' }}
                                  onClick={() => {
                                    handleEdit(row.id)
                                  }}
                                >
                                  <EditOutlinedIcon style={{ color: 'blue' }} />
                                </Button>
                              </TableCell>
                            </TableRow>
                          )
                        })}
                      {sortDataColors == '' ? (
                        <>
                          <TableRow
                            key='noRow1'
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                          >
                            <TableCell component='th' scope='row'></TableCell>
                            <TableCell align='right' scope='row'></TableCell>
                            <TableCell align='right'></TableCell>
                            <TableCell align='right'></TableCell>
                            <TableCell align='right'></TableCell>
                            <TableCell align='right'></TableCell>
                          </TableRow>
                          <TableRow
                            key='noRow'
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 }
                            }}
                          >
                            <TableCell component='th' scope='row'></TableCell>
                            <TableCell align='right' scope='row'></TableCell>
                            <TableCell align='right'></TableCell>
                            <TableCell align='right'></TableCell>
                            <TableCell align='right'></TableCell>
                            <TableCell align='right'></TableCell>
                          </TableRow>
                        </>
                      ) : (
                        ''
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Grid>
          </Grid>
        </Box>
      </form>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {dialogContent}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{Close}</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  )
}

export default FormViewListColor
